<span class="flex justify-between gap-4" data-test-class="receipt-extra">
	<span class="flex flex-col" data-test-id="receipt-extra-title">
		<span>
			@if (extra().amount) {
				{{ extra().amount }}<span aria-hidden="true">x </span>
			}
			@if (extra().name) {
				{{ extra().name }}
			} @else {
				{{ 'global.unspecified-extra-text' | translate }}
			}
		</span>
		<span
			class="text-xs text-dark-tertiary md:text-sm"
			data-test-id="receipt-extra-date"
			>{{ extra().datesLabel }}</span
		>
	</span>
	<span class="my-auto" data-test-id="receipt-extra-price">
		{{ extra().price | price: currency() }}
	</span>
</span>
